import { Box, ImageListItem, Slider, TextField } from '@mui/material';
import React, { useState } from 'react';

const DegreeSlider = ({ data, onChange }) => {
    const [value, setValue] = useState(data.offset_360_degree || 0);
    const [imageLoaded, setImageLoaded] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        onChange(newValue);
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };


    return (
        <>
            <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                <ImageListItem>
                    <img src={data.link} alt="Doc img" loading="lazy" onLoad={handleImageLoad} style={{
                        maxHeight: 'calc(40vh - 125px)',
                        width: '100%',
                        objectFit: 'contain'
                    }} />
                </ImageListItem>
                {imageLoaded && (
                    <>
                        <Slider
                            value={value}
                            onChange={handleChange}
                            aria-labelledby="continuous-slider"
                            min={0}
                            max={360}
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '0',
                                width: '100%',
                                // '&& .MuiSlider-thumb': {
                                //     width: '2px',
                                //     height: '40px',
                                //     backgroundColor: 'currentColor',
                                //     border: 'none',
                                //     '&:hover, &.Mui-focusVisible': {
                                //         boxShadow: 'inherit',
                                //     },
                                // },
                            }}
                        />
                    </>
                )}
            </Box>
            <TextField
                value={`${value}°`}
                label="North offset"
                InputProps={{
                    readOnly: true,
                }}
                variant="filled"
                sx={{
                    width: '100px',
                    marginTop: '0.5rem',
                }}
            />
        </>
    );
};

export default DegreeSlider;